import voca from "voca";

import { parseDate } from "../common/Hooks";
import { ConnectionLogAttributes } from "../attributes/connection-log-attributes";
import moment from "moment";

class ConnectionLog {
  connection_status: number;
  ipv4_address: string;
  ipv6_address: string | null;
  created_at: Date;
  device_name: string | null;
  device_model: string | null;

  constructor(
    connection_status: number,
    ipv4_address: string,
    ipv6_address: string | null,
    created_at: Date,
    device_name: string | null,
    device_model: string | null
  ) {
    this.connection_status = connection_status;
    this.ipv4_address = ipv4_address;
    this.ipv6_address = ipv6_address;
    this.created_at = created_at;
    this.device_name = device_name;
    this.device_model = device_model;
  }

  static fromJson(json: ConnectionLogAttributes): ConnectionLog {
    if (json === null || json === undefined) {
      return null;
    }

    return new ConnectionLog(
      json.connection_status,
      json.ipv4_address,
      json.ipv6_address,
      parseDate(json.created_at),
      json.device_name,
      json.device_model
    );
  }

  device(): string | null {
    if (this.device_name && this.device_model) {
      return voca.titleCase(this.device_name + ", " + this.device_model);
    }

    if (this.device_name) return voca.titleCase(this.device_name);
    if (this.device_model) return voca.titleCase(this.device_model);

    return null;
  }

  displayLastConnection(): any {
    const device = this.device();

    if (device !== null) {
      return {
        message: "sharedScreen.enterPinToLogin",
        values: {
          device: device,
          date: moment(this.created_at).fromNow(),
        },
      };
    }

    return {
      message: "sharedScreen.enterPinToLoginWithoutDevice",
      values: {
        date: moment(this.created_at).fromNow(),
      },
    };
  }
}

export default ConnectionLog;
